import { Grid, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import {
  RegistrationMarriageFormVM,
  SearchMarriageFormVM,
} from 'mutation/view-models/registration-marriage';
import ErrorModal from 'mutation/components/shared/error-modal';
import FormSearchPerson from 'shell/components/shared/search-person';
import { PersonalDataSearchVM } from 'shell/view-models/personal-data';
import { transformMarriage } from 'shell/utils/consult-person/response-transformer/marital-status/marriage';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { AccordionMarriage } from 'shell/view-models/accordion-marriage';
import { initialValuesRegistrationMarriage } from 'mutation/utils/transformer-registration-marriage';
import PmiDivider from 'shell/components/shared/divider';

interface SearchMarriageFormProps {
  disabled?: boolean;
  values?: SearchMarriageFormVM;
  onChange: (
    key: keyof RegistrationMarriageFormVM,
    value: RegistrationMarriageFormVM[keyof RegistrationMarriageFormVM]
  ) => void;
  onChangeValues: (values: RegistrationMarriageFormVM) => void;
  isOpenStartAccordion?: boolean;
}

const SearchMarriageFormComponent = ({
  values,
  onChange,
  onChangeValues,
  disabled,
  isOpenStartAccordion,
}: SearchMarriageFormProps): React.ReactElement => {
  const [openError, setOpenError] = useState<boolean>(false);

  const onCloseErrorModal = useEventCallback((value: boolean) => {
    setOpenError(value);
  });

  const onMarriageFieldsChange = useEventCallback((fields: PersonalDataSearchVM) => {
    const marriageData = transformMarriage(fields.subjectData || {});

    const person = transformPerson(fields.subjectData || {});

    // const canBeMutated = checkPersonRegistrationMarriage(
    //   fields?.subjectData?.statoCivile?.statoCivile
    // );

    // if (!canBeMutated) {
    //   // persona già coniugata
    //   setOpenError(true);
    //   return;
    // }

    onChangeValues({
      searchMarriage: {
        ...initialValuesRegistrationMarriage.searchMarriage,
        ...fields,
      },
      marriage: {
        ...initialValuesRegistrationMarriage.marriage,
        ...(marriageData || {}),
        generality: fields.generality,
        person,
      },
    });
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormSearchPerson
          disabled={disabled}
          onChangeFields={onMarriageFieldsChange}
          values={values}
          onChange={
            onChange as (
              key: keyof AccordionMarriage,
              value: AccordionMarriage[keyof AccordionMarriage]
            ) => void
          }
          isOpenStartAccordion={isOpenStartAccordion}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiDivider />
      </Grid>
      <ErrorModal open={openError} onClose={onCloseErrorModal} />
    </Grid>
  );
};

SearchMarriageFormComponent.displayName = 'search marriage form component';

const SearchMarriageForm = memo(SearchMarriageFormComponent);

export default SearchMarriageForm;
